export default {
  inject: ['load'],
  data() {
    return {};
  },
  methods: {
    getPatientDetailByFollowupFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientDetailByFollowup', id).then(() => {
        if (this.$store.state.patientDetailModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientDetailModule.patientDetail;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDetailModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDetailModule.successFlag) {
                this.getPatientDetailByFollowupFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getPatientDetailForStep1: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientDetailByFollowup', id).then(() => {
        if (this.$store.state.patientDetailModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientDetailModule.patientDetail;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              if (temp.typeOfEmergency.id == 1) {
                this.$root.$refs.FollowUpPatient.missionMainType = 'truma';
              } else {
                this.$root.$refs.FollowUpPatient.missionMainType = 'illness';
              }
              this.$root.$refs.FollowUpPatient.hasMisssionType = true;
            } else {
              this.$root.$refs.FollowUpPatient.hasMisssionType = false;
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDetailModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDetailModule.successFlag) {
                this.getPatientDetailForStep1(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientDetailFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientDetail', data).then(() => {
        if (this.$store.state.patientDetailModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.patientDetailAdded();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDetailModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDetailModule.successFlag) {
                this.addPatientDetailFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientDetailModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
